import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { ApiError } from '@root/globalTypes';
import { RoutesDropdownRespSuccess } from './types';
import { useAppContext } from '@contexts/app';

export const useRoutesDropdown = () => {
  const { isDropdownEnabled: enabled } = useAppContext();

  const { data, error, isFetching } = useQuery<RoutesDropdownRespSuccess, ApiError>({
    queryKey: queryKeys.dropdowns.routes,
    queryFn: () => queryFetch({ url: 'dropdowns/routes' }),
    placeholderData: (previousData) => previousData as RoutesDropdownRespSuccess,
    enabled,
  });

  return {
    data,
    error,
    isLoading: isFetching,
  };
};
